module.exports = __webpack_public_path__ + "img/balibodySh2.afda0493.jpg";